import { render, staticRenderFns } from "./history_home.vue?vue&type=template&id=58151a62&scoped=true&"
import script from "./history_home.vue?vue&type=script&lang=js&"
export * from "./history_home.vue?vue&type=script&lang=js&"
import style0 from "./history_home.vue?vue&type=style&index=0&id=58151a62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58151a62",
  null
  
)

export default component.exports